import React from 'react'
import EventsSection from './EventsSection'

function MainContent() {
   return (
      <div className="px-4 sm:px-6 lg:px-8">
         <div className='w-full flex flex-col items-center py-6 sm:py-8'>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold leading-snug md:leading-normal mb-2 sm:mb-4 text-dark-1 dark:text-white text-center">
               Events
            </h1>
            <span className='font-sans text-gray-600 dark:text-gray-400 text-sm sm:text-base text-center max-w-md'>
               We're on a mission to deliver engaging, curated courses at a reasonable price.
            </span>
         </div>
         <EventsSection />
      </div>
   )
}

export default MainContent